export default Object.freeze({
  HIDE_HEADERS: 'hideHeaders',
  HEADER_MESSAGE: 'headerMessage',
  FUEL_MESSAGES: 'fuelMessages',
  FUEL_SUBMISSION_TITLE: 'fuelSubmissionTitle',
  FUEL_ERROR_NOTIFICATIONS: 'fuelErrorNotifications',
});
